import { AxiosInstance } from 'axios';
import { PaginatedResponse } from '../../types';
import { CreateManualPlan, DueInstallment, PaymentPlan, PaymentPlanSummary } from '../../types/paymentPlan';

export class PaymentPlanApi {
  constructor(private readonly http: AxiosInstance) {}

  async list(customerId: string, page = 0): Promise<PaginatedResponse<PaymentPlan>> {
    return (await this.http.get('/payment-plans', { params: { customerId, page, size: 100 } })).data;
  }

  async create(data: CreateManualPlan): Promise<PaymentPlan> {
    return (await this.http.post('/payment-plans/manual-debt', data)).data;
  }

  async due(params: { from?: string; to?: string; page: number; size?: number }): Promise<PaginatedResponse<DueInstallment>> {
    return (await this.http.get('/payment-plans/due', { params })).data;
  }

  async summary(): Promise<PaymentPlanSummary> {
    return (await this.http.get('/payment-plans/summary')).data;
  }

  async pay(planId: string, amount: number): Promise<{ paymentDebtId: string; plan: PaymentPlan }> {
    return (await this.http.post(`/payment-plans/${planId}/payments`, { amount })).data;
  }

  async cancel(planId: string): Promise<PaymentPlan> {
    return (await this.http.post(`/payment-plans/${planId}/cancel`)).data;
  }

  async update(planId: string, data: { title: string; installmentCount: number; firstDueDate: string }): Promise<PaymentPlan> {
    return (await this.http.patch(`/payment-plans/${planId}`, data)).data;
  }

  async reverse(planId: string, paymentId: string): Promise<{ paymentDebtId: string; plan: PaymentPlan }> {
    return (await this.http.post(`/payment-plans/${planId}/payments/${paymentId}/reverse`)).data;
  }
}
